import { Gearbox, GithubLogo } from "@gearbox-protocol/deploy-tools-ui";
import type { NavBarItem } from "components/NavBar";
import NavBar from "components/NavBar";
import { useVersion } from "hooks/useVersion";
import type { FC } from "react";
import { Link, Outlet, useLoaderData } from "react-router-dom";

import { URL_BASE } from "../constants";
import AdminMenu from "./AdminMenu";

const rootNav: NavBarItem[] = [
  { path: "/forks", title: "Testnets" },
  { path: "/optimist", title: "Optimist" },
  { path: "/task-definitions", title: "Task Definitions" },
  { path: "/whitelist", title: "Whitelist" },
  { path: "/sdk", title: "SDK Live" },
  { path: "/monitoring", title: "Monitoring" },
];

const RootRoute: FC = () => {
  const apiVersion = useLoaderData() as string;
  const frontendVersion = useVersion();

  return (
    <div className="container mx-auto flex flex-col flex-1 p-4 gap-y-2">
      <div className="flex flex-row items-center justify-between">
        <Link to="/">
          <h1 className="text-white">
            <Gearbox size={48} className="inline-block mb-2" />
            Gearbox testnet
          </h1>
        </Link>
        <AdminMenu />
      </div>

      <div className="text-gray-200 bg-background rounded-xl p-4">
        <NavBar items={rootNav} pattern="/" />
      </div>

      <Outlet />

      <div className="mt-auto pt-8 pb-4 text-gray-400 text-sm flex items-center justify-between">
        <div>© {new Date().getFullYear()} Gearbox Protocol</div>
        <div className="flex flex-row items-center divide-x-2 *:px-2 -mx-2 divide-gray-600">
          <div>{`API version: ${apiVersion}`}</div>
          <div>{`App version: ${frontendVersion}`}</div>
          <a
            href={`${URL_BASE}/api/v1/docs`}
            target="_blank"
            className="hover:text-gray-200 transition-colors"
            rel="noopener"
          >
            API docs
          </a>
          <a
            href="https://github.com/gearbox-protocol/anvil-manager"
            target="_blank"
            className="hover:text-gray-200 transition-colors"
            rel="noopener"
          >
            <GithubLogo size={24} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default RootRoute;
